import params$ from './params';
import hashCalculator from '../hashCalculator';
import createServiceObservables from './createServiceObservable';

const observables = createServiceObservables(
    'hashes',
    params$,
    async (params) => {
        const binaryImage = new Uint8Array(await params.file.arrayBuffer());
        return await hashCalculator.calculateBoth(binaryImage, params.photo.signal);
    },
);
const hashesErrors$ = observables.errorsOnly$;
const hashes$ = observables.withoutErrors$;

export { hashesErrors$ };
export default hashes$;
